import React from "react";
import {CommonUtil} from "../../utils/CommonUtil";

const EquipCellRenderer = (props:any)=>{
    const onClickLink = ()=>{
        if(props.context){
            //localStorage.setItem("userId","krishna");
            localStorage.setItem("ViewTab","true");
            let siteOrigin:string = window.location.origin;
            siteOrigin = siteOrigin+"/?requestor=";//equipview&equipid="+props.data.equipmentId+"&screenType="+CommonUtil.SCREEN_NAME;//+"&token="+ localStorage.getItem("token");;
            let strPath = "equipview&equipid="+props.data.equipmentId+"&screenType="+CommonUtil.SCREEN_NAME;
            siteOrigin = siteOrigin+strPath;
            //CommonUtil.addScreensToLastAccessed(strPath);
            var newTab = document.createElement('a');
            newTab.href = siteOrigin;
            newTab.setAttribute('target', '_blank');
            newTab.click();

            /*let siteOrigin:string = window.location.origin;
            siteOrigin = siteOrigin+"/?requestor=equipview";
            window.location.assign(siteOrigin);*/
            //props.context.onClickLink(props.data);

            //props.context.onClickLink(props.data);
        }
    }
    return(
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickLink} className={"cellRender"}>{props.data.unitNumber?props.data.unitNumber:props.data.genericEquipmentName}</span></a>
        </div>

    )
}

export default EquipCellRenderer;